jQuery(document).ready(function () {
  $ = jQuery;

  if (!$('body.page-register-warranty').length) {
    return;
  }

  function KlaviyoSubscribeWarranty(listID, formData, source) {
    var subscribed = false;

    var formattedData = {
      g: listID,
      $source: source,
      $fields: '',
      $consent: [],
      sms_consent: false,
      'Accepts Marketing': true,
      'Accepts SMS': false,
    };

    console.log('here');

    formData.forEach(function (value, key) {
      if (key === 'name') {
        var names = value.split(' ');
        formattedData.$first_name = names[0];
        formattedData.$last_name = names[1];
        formattedData.$fields += '$first_name, $last_name, $consent, $source, ';
      } else if (key === 'email') {
        formattedData.$email = value;
        formattedData.$consent.push('email');
        formattedData['Consent Status'] = true;
        formattedData.$fields += '$email, email_consent, Accepts Marketing, ';
      } else if (key === 'phone number') {
        formattedData.$phone_number = value;
        formattedData.$consent.push('sms');
        formattedData.sms_consent = true;
        formattedData.$fields += '$phone_number, sms_consent, Accepts SMS, ';
      } else if (key === 'producttype') {
        formattedData['Product Type'] = value;
        formattedData.$fields += 'Product Type, ';
      } else if (key === 'place of purchase') {
        formattedData['Place of Purchase'] = value;
        formattedData.$fields += 'Place of Purchase, ';
      } else if (key === 'address line 1') {
        formattedData['Address'] = value;
      } else if (key === 'address line 2') {
        formattedData['Address'] += ', ' + value;
      } else if (key === 'city') {
        formattedData['Address'] += ', ' + value;
      } else if (key === 'state') {
        formattedData['Address'] += ', ' + value;
      } else if (key === 'zip code') {
        formattedData['Address'] += ' ' + value;
        formattedData.$fields += 'Address, ';
      }
    });

    formattedData.$fields = formattedData.$fields.replace(/,\s*$/, '');

    console.log(formattedData);

    $.post(
      'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
      formattedData
    )
      .done(function (res) {
        console.log(res);
        subscribed = true;
        var isSubscribed = res.data.is_subscribed;
        var klaviyoForm = $('#klaviyo-warranty-form');
        var klaviyoMessage = $('#klaviyo-warranty-message');

        if (!isSubscribed) {
          klaviyoForm.css('opacity', '0.25');
          klaviyoForm.css('pointer-events', 'none');
          var msg = '<p class="h2">Your registration is confirmed!</p>';
          klaviyoMessage.append(msg);
        } else {
          klaviyoForm.css('opacity', '0.25');
          klaviyoForm.css('pointer-events', 'none');
          var msg =
            '<p class="h2">It looks like you\'ve already registered a product with us – if you think there\'s an issue reach out to Yo@nocsprovisions.com</p>';
          klaviyoMessage.append(msg);
        }
      })
      .fail(function (err) {
        console.log('Could not connect to Klaviyo.');
        console.log(err);
      });

    return subscribed;
  }

  $('#submit-warranty-form').click(function (event) {
    event.preventDefault();
    const $form = $('#klaviyo-warranty-form').get(0);
    const listID = $($form).data('listid');
    const formData = new FormData($form);
    const source =
      "Form submitted from the '" +
      document.title +
      "' page located at " +
      document.URL;

    var nameExists = false,
      emailExists = false;

    formData.forEach(function (value, key) {
      if (key === 'name') nameExists = value !== '';
      if (key === 'email') emailExists = value !== '';
    });

    //console.log('inside here');

    if (nameExists && emailExists) {
      KlaviyoSubscribeWarranty(listID, formData, source);
    } else {
      // code to highlight required fields
    }
  });
});
